import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import StateSelect from "components/StateSelect";

interface AddressFormValues {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
}

interface AddressFormProps {
  // Formik handlers — broad element type so they satisfy both the
  // Form.Control (input) sinks and StateSelect's HTMLSelectElement handlers.
  handleChange: React.ChangeEventHandler<HTMLElement>;
  handleBlur: React.FocusEventHandler<HTMLElement>;
  values: AddressFormValues;
  // PropTypes had these as bare `object`; tightened to the fields actually read
  // here and forwarded to StateSelect ({ state?: ... }).
  touched: { [K in keyof AddressFormValues]?: boolean };
  errors: { [K in keyof AddressFormValues]?: string };
}

const AddressForm = ({
  handleChange,
  handleBlur,
  values,
  touched,
  errors,
}: AddressFormProps) => {
  return (
    <>
      <Form.Group className="mb-3" controlId="formAddress1">
        <Form.Label>Address 1</Form.Label>
        <Form.Control
          name="address1"
          placeholder="Address 1"
          value={values.address1}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.address1 && !!errors.address1}
          isValid={touched.address1 && !errors.address1}
        />
        <Form.Control.Feedback type="invalid">
          {errors.address1}
        </Form.Control.Feedback>
      </Form.Group>

      <Form.Group className="mb-3" controlId="formAddress2">
        <Form.Label>Address 2</Form.Label>
        <Form.Control
          name="address2"
          placeholder="Address 2"
          value={values.address2}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={touched.address2 && !!errors.address2}
          isValid={touched.address2 && !errors.address2}
        />
        <Form.Control.Feedback type="invalid">
          {errors.address2}
        </Form.Control.Feedback>
      </Form.Group>

      <Row className="mb-3">
        <Form.Group as={Col} controlId="formCity">
          <Form.Label>City</Form.Label>
          <Form.Control
            name="city"
            placeholder="City"
            value={values.city}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.city && !!errors.city}
            isValid={touched.city && !errors.city}
          />
          <Form.Control.Feedback type="invalid">
            {errors.city}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} sm={4} controlId="formState">
          <Form.Label>State</Form.Label>
          <StateSelect
            value={values.state}
            handleChange={handleChange}
            handleBlur={handleBlur}
            touched={touched}
            errors={errors}
          />
        </Form.Group>

        <Form.Group as={Col} sm={3} controlId="formPostalCode">
          <Form.Label>Zip</Form.Label>
          <Form.Control
            name="postalCode"
            placeholder="Zip"
            value={values.postalCode}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.postalCode && !!errors.postalCode}
            isValid={touched.postalCode && !errors.postalCode}
          />
          <Form.Control.Feedback type="invalid">
            {errors.postalCode}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export default AddressForm;
